import React from 'react'
import { handleDelete } from '../../../../utils/actions'
import { ReferenceComponent } from './components';
import { pushRouteFromEditor, type EditorRouteData } from '../utils/pushRouteFromEditor';


export const InlineReference = ({ entry, editor, element, ...props }) => {
  const { history, apiKey } = editor?.requestProps || {};
  const currentBranch = editor?.requestProps?.branch
  const contentTypeUid = element?.attrs?.['content-type-uid'],
    entryUid = element?.attrs?.['entry-uid'],
    locale = element?.attrs?.['locale'];

  const handleEdit = (e: Event) => {
    if (editor?.referenceActions?.editInlineReference) {
      editor.referenceActions.editInlineReference({ contentTypeUid, entryUid, locale })
      return;
    }
    const pathname = `/stack/${apiKey}/content-type/${contentTypeUid}/${locale}/entry/${entryUid}/edit`
    const search = currentBranch ? `branch=${currentBranch}` : ''
    const state = editor.isDraft ? editor.getReferredObj({ ctUid: contentTypeUid, blockUid: element.uid, pathname, search }) : {}
    
    const newHistoryData: EditorRouteData = {
      pathname,
      search,
      ...(editor.isDraft ? { state } : {}),
    }
    
    pushRouteFromEditor(editor, newHistoryData)
  }

  const handleOpenInModal = editor?.isEntryInModalEnabled
    ? () => editor?.openEmbeddedEntryInModal?.({ entryUid, contentTypeUid, locale })
    : undefined

  return (
    <ReferenceComponent type='inline' entry={entry} editor={editor} content_type_uid={contentTypeUid} handleEdit={handleEdit} handleOpenInModal={handleOpenInModal} handleDelete={() => handleDelete(editor, element)} attributes={{ ...props.attributes, ...props.attrs, element }} children={props.children} />
  )
}

export * from './withInlineReference'
export * from './components'
export * from './deserializer'